/* Qalbeen · HOVER : méga-menu ordinateur (survol, clic, clavier, Échap). Le tiroir mobile est géré par hover.js. */
(function () {
  var D = document;
  function lier(m) {
    if (m._hv) return; m._hv = 1;
    var btn = m.querySelector('.hv-dnav__a'), t = null, survol = false;
    var ouvrir = function () { clearTimeout(t); m.classList.add('on'); btn.setAttribute('aria-expanded', 'true'); };
    var fermer = function () { clearTimeout(t); survol = false; m.classList.remove('on'); btn.setAttribute('aria-expanded', 'false'); };
    var fin = function (ms) { clearTimeout(t); t = setTimeout(fermer, ms); };
    m.addEventListener('pointerenter', function (e) { if (e.pointerType === 'touch') return; clearTimeout(t); t = setTimeout(function () { ouvrir(); survol = true; }, 90); });
    m.addEventListener('pointerleave', function (e) { if (e.pointerType === 'touch') return; fin(180); });
    btn.addEventListener('click', function (e) { e.preventDefault(); if (m.classList.contains('on') && !survol) fermer(); else ouvrir(); survol = false; });
    m.addEventListener('focusout', function (e) { if (!m.contains(e.relatedTarget)) fin(60); });
    m.addEventListener('keydown', function (e) { if (e.key === 'Escape' && m.classList.contains('on')) { fermer(); btn.focus(); } });
    D.addEventListener('click', function (e) { if (m.classList.contains('on') && !m.contains(e.target)) fermer(); });
  }
  function init(c) { Array.prototype.forEach.call((c || D).querySelectorAll('[data-hv-mega]'), lier); }
  init(D);
  D.addEventListener('shopify:section:load', function (e) { init(e.target); });
  /* éditeur : ouvrir le méga-menu quand on sélectionne un de ses blocs */
  D.addEventListener('shopify:block:select', function (e) {
    var m = e.target.closest && e.target.closest('[data-hv-mega]'); if (m) { m.classList.add('on'); }
  });
  D.addEventListener('shopify:block:deselect', function (e) {
    var m = e.target.closest && e.target.closest('[data-hv-mega]'); if (m) { m.classList.remove('on'); }
  });
})();
